const API_BASE_ADDRESS = 'http://localhost:4000';

export default class Api {
    static getExceptions() {
        const uri = API_BASE_ADDRESS + "/exceptions";

        return fetch(uri, {
            method: 'GET'
        });
    }
}